import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=56578bbd&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56578bbd')) {
      api.createRecord('56578bbd', component.options)
    } else {
      api.reload('56578bbd', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=56578bbd&", function () {
      api.rerender('56578bbd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2B6pihqP2K7c4/JS/comp/ErrorMessage.vue"
export default component.exports